
export interface RouteInfo {
  navigate?: string | any[];
  label: string;
}
